import { addElementAtIndex, notifyDataUpdationFromSocket, flashCellOnce } from "../utils";
import { getUniqueId } from "utils/Utils";
import { modifyHighlightedCellsCountDuringSocketUpdation } from "./duplicateCellsCountUpdationHandler";

export function dataUpdationFromSocket(store, targetnode, updatedRowsData) {
    try {
        const oldNodeData = {...targetnode};
        if (targetnode?.data && targetnode?.data?.comments && targetnode?.data?.comments.length > 0) {
            updatedRowsData['comments'] = targetnode.data.comments ?? [];
            updatedRowsData['comments_count'] = targetnode.data.comments_count ?? 0;
        }
        console.log("into dataUpdationFromSocket");
        targetnode.setData(updatedRowsData);
        // Check if you need to redraw or refresh the row/cell or not.
        if (!store.isLazyLoadEnabled) {
            if (store.allRowsData[targetnode.rowIndex]) {
                store.allRowsData[targetnode.rowIndex] = targetnode.data;
            } else {
                for (let i=0; i<store.newRows.length; i++) {
                    if (store.newRows[i].row_id == targetnode.data.row_id) {
                        store.newRows[i] = targetnode.data;
                        break;
                    }
                }
            }
        }
        if (Object.keys(store?.duplicateColumnsData).length > 1) {
            modifyHighlightedCellsCountDuringSocketUpdation(store, targetnode.data, oldNodeData);
        }
        store.refreshGroupedColHeaderWhileUpdation(targetnode);
    } catch (error) {
        console.log('Data updation error through socket. ', error);
    }
}

export function addingRowsFromSocketLazyLoad(store, newRows, userName = "", fromWebFormOrEmail = false, fromTriggers = false) {
    try {
        let rowsToBeFlashed = [];
        const emptyRowIdxInNewRows = store.newRows.findIndex(row => !row.row_id);
        if (newRows.length <= store.newRows.length && emptyRowIdxInNewRows >= 0) {
            console.log("into addingRowsFromSocketLazyLoad if case...");
            newRows.forEach(row => {
                const lastRowIndexVisible = store.gridApi.isLastRowIndexKnown();
                let isRowExisting = false;
                const checkRowNode = store.getRowNodeById(row.row_id, row?.uniqueId ?? '').node;
                if (checkRowNode && checkRowNode.data.row_id) {
                    isRowExisting = true;
                }
                if (lastRowIndexVisible && !isRowExisting) {
                    let targetNode = store.gridApi.getRowNode(store.newRows[emptyRowIdxInNewRows].uniqueId);
                    if (row.uniqueId) {
                        let alreadyExistingNode = store.gridApi.getRowNode(row.uniqueId);
                        if (alreadyExistingNode) {
                            alreadyExistingNode.data.uniqueId = getUniqueId();
                            alreadyExistingNode.setData(alreadyExistingNode.data);
                            alreadyExistingNode.id = alreadyExistingNode.data.uniqueId;
                        }
                    }
                    if (targetNode && targetNode.data) {
                        const newRow = row;
                        newRow['uniqueId'] = row?.uniqueId ?? row.row_id;
                        for (let column of store.columnDefs) {
                            if (column.aliasPath == 'createdBy') {
                                newRow[column.field] = row['createdBy'] ?? row[column.field];
                                break;
                            }
                        }
                        targetNode.setData(newRow);
                        targetNode.id = targetNode.data.uniqueId;
                        store.gridApi.refreshCells({
                            rowNodes: [targetNode],
                            columns: ["userEvents"],
                            force: true,
                        });
                        store.newRows[emptyRowIdxInNewRows] = targetNode.data;
                        rowsToBeFlashed.push(targetNode);
                        if (Object.keys(store?.duplicateColumnsData).length > 1) {
                            modifyHighlightedCellsCountDuringSocketUpdation(store, targetNode, {}, true);
                        }
                    }
                }
            });
        } else {
            console.log("into addingRowsFromSocketLazyLoad else case...");
            const lastRowIndexVisible = store.gridApi.isLastRowIndexKnown();
            if (lastRowIndexVisible) {
                let rowCount = store?.gridApi.getInfiniteRowCount();
                store?.gridApi.setRowCount(rowCount + 1);
            }
            store?.gridApi.refreshInfiniteCache();
            let checkCount = 0;
            let interval = setInterval(() => {
                let foundRows = [];
                for (let row of newRows) {
                    let targetNode = store.getRowNodeById(row?.row_id).node;
                    if (targetNode) {
                        foundRows.push(targetNode);
                    } else {
                        break;
                    }
                }
                if (foundRows.length === newRows.length || checkCount >= 50) {
                    if (foundRows.length > 0) {
                        let rowAlertMessage = "New row(s) added by ";
                        notifyDataUpdationFromSocket(rowAlertMessage, userName, foundRows, [], store, fromWebFormOrEmail, fromTriggers);
                    }
                    clearInterval(interval);
                }
                checkCount++;
            }, 100);
        }
        return rowsToBeFlashed;
    } catch (error) {
        console.log('New row addition error in lazyload through socket. ', error);
    }
}

export function addingRowsFromSocketLoadAllRows(store, newRows, userName, isSubsheet = false, fromWebFormOrEmail = false, fromTriggers = false, shouldNotify = true) {
    try {
        let createdBy = '';
        let createdByColId = '';
        newRows.forEach(row => {
            let check = true;
            let newRow = {...row};
            newRow['uniqueId'] = row?.uniqueId ?? row.row_id;
            if (createdBy !== '' && createdByColId !== '') {
                newRow[createdByColId] = createdBy;
            } else {
                for (let column of store.columnDefs) {
                    if (column.aliasPath == 'createdBy') {
                        newRow[column.field] = row['createdBy'] ?? row[column.field];
                        createdBy = newRow[column.field];
                        createdByColId = column.field;
                        break;
                    }
                }
            }
            if (!newRow.hasOwnProperty('comments_count')) {
                newRow['comments_count'] = "0"
            }
            if (isSubsheet) {
                let parentRowId = store?.parentRowId ?? 0;
                if (row.hasOwnProperty('reference_' + store?.parentListId)) {
                    parentRowId = row['reference_' + store?.parentListId];
                }
                newRow['reference_' + store.parentListId] = parentRowId;
                newRow['id'] = newRow.row_id;
                check = parentRowId == store?.parentRowId;
            }
            if (check) {
                const targetNode = newRow?.uniqueId ? store.gridApi.getRowNode(newRow.uniqueId) : null;
                if (targetNode && targetNode.data && !targetNode.data.row_id) {
                    targetNode.data = newRow;
                    targetNode.setData(newRow);
                    store.gridApi.refreshCells({
                        rowNodes: [targetNode],
                        columns: ["userEvents"],
                        force: true,
                    });
                    addElementAtIndex(store, targetNode.rowIndex, targetNode.data);
                    let rowAlertMessage = shouldNotify ? "New row(s) added by " : `Row ${newRow.row_id} updated by `;
                    notifyDataUpdationFromSocket(rowAlertMessage, userName, [targetNode], [], store, fromWebFormOrEmail, fromTriggers);
                    if (Object.keys(store?.duplicateColumnsData).length > 1) {
                        modifyHighlightedCellsCountDuringSocketUpdation(store, targetNode, {}, true);
                    }
                    store.refreshGroupedColHeaderWhileUpdation(targetNode);
                } else if (!targetNode || !targetNode.data || !targetNode.data.row_id) {
                    store?.gridApi?.applyTransactionAsync(
                        { add: [newRow] },
                        (transactionResult) => {
                            if (transactionResult?.add[0]) {
                                addElementAtIndex(store, transactionResult?.add[0].rowIndex, transactionResult?.add[0].data);
                                let rowAlertMessage = shouldNotify ? "New row(s) added by " : `Row ${newRow.row_id} updated by `;
                                notifyDataUpdationFromSocket(rowAlertMessage, userName, [transactionResult?.add[0]], [], store, fromWebFormOrEmail, fromTriggers);
                                if (Object.keys(store?.duplicateColumnsData).length > 1) {
                                    modifyHighlightedCellsCountDuringSocketUpdation(store, transactionResult?.add[0], {}, true);
                                }
                                getUniqueId();
                                store.refreshGroupedColHeaderWhileUpdation(transactionResult?.add[0]);
                            }
                        }
                    );
                }
            }
        });
    } catch (error) {
        console.log('New row addition error through socket. ', error);
    }
}

export function addNewSubsheetRowsToGrid (store, newRows) {
    try {
        let createdBy = '';
        let createdByColId = '';
        newRows.forEach(row => {
            let newRow = {...row};
            if (createdBy !== '' && createdByColId !== '') {
                newRow[createdByColId] = createdBy;
            } else {
                for (let column of store.columnDefs) {
                    if (column.aliasPath == 'createdBy') {
                        newRow[column.field] = row['createdBy'] ?? row[column.field];
                        createdBy = newRow[column.field];
                        createdByColId = column.field;
                        break;
                    }
                }
            }
            const isRowExisting = store.getRowNodeById(row.row_id, row?.uniqueId ?? '').node;
            if (!isRowExisting) {
                store?.gridApi?.applyTransactionAsync(
                    { add: [newRow] },
                    (transactionResult) => {
                        if (transactionResult?.add[0]) {
                            addElementAtIndex(store, transactionResult?.add[0].rowIndex, transactionResult?.add[0].data);
                            flashCellOnce(store, [transactionResult?.add[0]], [], 5000);
                            if (Object.keys(store?.duplicateColumnsData).length > 1) {
                                modifyHighlightedCellsCountDuringSocketUpdation(store, transactionResult?.add[0], {}, true);
                            }
                            getUniqueId();
                            store.refreshGroupedColHeaderWhileUpdation(transactionResult?.add[0]);
                        }
                    }
                );
            }
        });
    } catch (error) {
        console.log('New row addition error in subsheet through socket. ', error);
    }
}

export function updateSubsheetRowsInGrid (store, updatedRows) {
    try {
        let createdByColId = '';
        let columns = {};
        for (let column of store.columns) {
            if (column.id !== 'row_id' && column.id !== 'event' && column.id !== 'column_+' && column?.alias_name !== 'star' && column?.alias_name !== 'createdBy'){
                columns[column.dataIndex] = column.alias_path;
            }
            if (column.alias_name == 'createdBy') {
                createdByColId = column.dataIndex;
            }
        }

        Object.entries(updatedRows).forEach(([rowId, rowData]) => {
            let matchedRowData = store?.getRowNodeById(rowId);
            let targetNode = matchedRowData.node;
            let matchedRowIdx = matchedRowData.matchedRowIdx;
            let columnsToBeFlashed = [];

            if (targetNode && targetNode.data) {
                const oldRowData = {...targetNode.data};
                Object.entries(columns).forEach(([columnId, aliasPath]) => {
                    if (targetNode.data[columnId] != rowData[columnId]) {
                        columnsToBeFlashed.push(aliasPath);
                    }
                });
                rowData[createdByColId] = targetNode.data[createdByColId];
                rowData['uniqueId'] = targetNode.data?.uniqueId;
                targetNode.setData(rowData);

                if (store.allRowsData[targetNode.rowIndex]) {
                    store.allRowsData[targetNode.rowIndex] = targetNode.data;
                } else {
                    store.newRows[matchedRowIdx] = targetNode.data;
                }

                flashCellOnce(store, [targetNode], columnsToBeFlashed, 5000);

                if (Object.keys(store?.duplicateColumnsData).length > 1) {
                    modifyHighlightedCellsCountDuringSocketUpdation(store, targetNode.data, oldRowData);
                }
                store.refreshGroupedColHeaderWhileUpdation(targetNode);
            }
        });
    } catch (error) {
        console.log('Data updation error in subsheet through socket. ', error);
    }
}

export function deletingRowsFromSocket(store, deletedRowIds, userName, shouldNotify = true) {
    try {
        let rowsToBeDeleted = [];
        let rowNodesToBeDeleted = [];
        let matchedRowIdxs = {};

        deletedRowIds.forEach(rowId => {
            let matchedRowData = store?.getRowNodeById(rowId);
            let rowNode = matchedRowData.node;
            matchedRowIdxs[rowId] = matchedRowData.matchedRowIdx;
            if (rowNode && rowNode.data) {
                rowsToBeDeleted.push(rowNode.data);
                rowNodesToBeDeleted.push(rowNode);
            }
        });
        if (rowsToBeDeleted.length > 0) {
            if (!store?.isLazyLoadEnabled) {
                store.gridApi.applyTransaction({ remove: rowsToBeDeleted });
            } else {
                if (store.refreshTimeout) {
                    clearTimeout(store.refreshTimeout);
                }

                store.refreshTimeout = setTimeout(() => {
                    store?.gridApi.refreshInfiniteCache();
                    store?.newRows.splice(0, store?.newRows.length);
                    notifyDataUpdationFromSocket(`${rowsToBeDeleted.length} row(s) deleted by `, userName, [], [], store);
                }, 1000);
            }

            rowNodesToBeDeleted.sort((a, b) => b.rowIndex - a.rowIndex);
            rowNodesToBeDeleted.map((node) => {
                if (!store?.isLazyLoadEnabled){
                    if (store.allRowsData[node.rowIndex]) {
                        store?.allRowsData.splice(node.rowIndex, 1);
                    } else {
                        store?.newRows.splice(matchedRowIdxs[node.data['row_id']], 1);
                    }
                    store.refreshGroupedColHeaderWhileUpdation(node);
                }
                if (Object.keys(store?.duplicateColumnsData).length > 1) {
                    modifyHighlightedCellsCountDuringSocketUpdation(store, node, {}, false, true);
                }
            });
            if (!store?.isLazyLoadEnabled && shouldNotify) {
                notifyDataUpdationFromSocket(`${rowsToBeDeleted.length} row(s) deleted by `, userName, [], [], store);
            }
        }
    } catch (error) {
        console.log('Row deletion error through socket. ', error);
    }
}